import { render, staticRenderFns } from "./FontPick.vue?vue&type=template&id=49456b84&scoped=true"
import script from "./FontPick.vue?vue&type=script&lang=js"
export * from "./FontPick.vue?vue&type=script&lang=js"
import style0 from "./FontPick.vue?vue&type=style&index=0&id=49456b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49456b84",
  null
  
)

export default component.exports